import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import {MatListModule} from '@angular/material/list';

@Component({
    selector: 'app-popup-dettaglio',
    imports: [MatButtonModule, MatDialogModule, MatListModule, CommonModule],
    templateUrl: './popup-dettaglio.component.html',
    styleUrl: './popup-dettaglio.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupDettaglioComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  
  anagraficaEntries: any[] = [];
  contatti: any[] = [];
  indirizzi: any[] = [];

  ngOnInit(): void {
    const obj = this.data.obj;

    // 1. Estrazione Liste (Nota: nel JSON è 'indirizzo' al singolare)
    this.contatti = obj.contatti || [];
    this.indirizzi = obj.indirizzo || [];

    // 2. Filtro Anagrafica: escludiamo ID, liste e oggetti complessi
    const keysToExclude = ['id', 'contatti', 'indirizzo', 'comune', 'tipoIndirizzo', 'usoIndirizzo'];
    
    this.anagraficaEntries = Object.entries(obj).filter(([key, value]) => {
      return !keysToExclude.includes(key) && 
             typeof value !== 'object' && 
             value !== null;
    });
  }

  formatKey(key: string): string {
    const mappings: { [key: string]: string } = {
      'codiceFiscale': 'Codice Fiscale',
      'qualifica': 'Qualifica/Ruolo'
    };
    return mappings[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
  }
}